import React from 'react';

export enum DemographicAppKeys {
    none = 'none',
    arc = 'arc',
    myCPG = 'myCPG',
}

export const DemographicsContext = React.createContext(DemographicAppKeys.none);